<template>
  <div id="lernzettel">
    <div id="frage" v-if="!ende">
      <h2 class="bl1">{{fragen[cq].frage}}</h2>
      <v-divider></v-divider>
      <v-list>
        <v-list-item-group v-model="model">
          <template v-for="(item, i) in fragen[cq].items">
            <v-list-item :key="`item-${i}`" :value="item" active-class="deep-purple--text text--accent-4" v-if="!eb || item.text == fragen[cq].solution">
              <template v-slot:default="{ active, toggle }">
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                  <v-img v-if="item.bild" :src="require('@/assets/' + item.bild)" contain></v-img>
                </v-list-item-content>
                <v-list-item-action v-if="!eb">
                  <v-checkbox :input-value="active" :true-value="item" @click="toggle"></v-checkbox>
                </v-list-item-action>
              </template>
              <v-divider :key="i"></v-divider>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
      <v-divider v-if=eb></v-divider>
      <v-card color="#2ecc71" v-if="eb && richtig">
        <v-card-title class="justify-center text-center ma-0 subtitle-1 pe"><v-icon>{{co}}</v-icon></v-card-title>
      </v-card>
      <v-card color="#e74c3c" v-if="eb && !richtig">
        <v-card-title class="justify-center text-center ma-0 subtitle-1 pe"><v-icon>{{skull}}</v-icon></v-card-title>
      </v-card>
      <v-divider v-if="eb"></v-divider>
      <v-card v-if="eb">
        <v-card-title class="title">
              <h5 class="tit">Erklärung</h5>
          </v-card-title>
          <v-card-text class="text">
              <p class="body-1 blackx">{{fragen[cq].erklärung}}</p>
          </v-card-text>
      </v-card>
      <v-divider></v-divider>
      <v-btn block outlined @click="goon()">Weiter</v-btn>
    </div>
    <div id="ergebnis" v-if="ende">
      <h1 class="text-center">{{this.kf + " / " + this.fragen.length}} <br />
        <v-icon v-if="this.kf != this.fragen.length" size="200px" color="#c0392b">{{skull}}</v-icon>
        <v-icon v-else size="200px" color="#2ecc71">{{co}}</v-icon>
      </h1>
      <v-divider></v-divider>
      <v-card href="https://lernzettel.org" color="#e67e22" target="_blank">
        <v-card-title class="title">
              <h5 class="tit">lernzettel.org</h5>
          </v-card-title>
          <v-card-text class="text">
              <p class="body-1">Plattform für Lernzettel, Präsentationen und Hausarbeiten.</p>
          </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-card href="https://zweig.lernzettel.org" color="#2ecc71" target="_blank">
        <v-card-title class="title">
              <h5 class="tit">Stefan Zweig</h5>
          </v-card-title>
          <v-card-text class="text">
              <p class="body-1">Gesammelte Werke</p>
          </v-card-text>
    </v-card>
    </div>
  </div>
</template>

<style scoped>
.bl1 {
  color: #2f5496;
}
.tit{
    margin: 0px 0px 0px;
}
.blackx{
  color: black;
}
.pe{
  padding-bottom: 16px;
}
</style>

<script>
import { mdiVirusOutline } from '@mdi/js';
import { mdiSkullCrossbonesOutline } from '@mdi/js';
import { mdiCheckOutline } from '@mdi/js'
  import { db } from '../db'
  const lernzettelp = db.collection('zweig');
  export default {
    name: 'lernzettel',
    data() {
      return {
        lernzettel: {},
        richtig: false,
        eb: false,
        kf: 0,
        virus: mdiVirusOutline,
        cq: 0,
        co: mdiCheckOutline,
        skull: mdiSkullCrossbonesOutline,
        fragen: [{
          frage: "Zu welcher Wahrscheinlichkeit waren Sie ca. bereits mit einem Coronavirus infiziert?",
          items: [
            {text: '0 - 5 %'},
            {text: '5 - 10 %'},
            {text: '> 10 %'}
          ],
          solution: "> 10 %",
          erklärung: "Von den sieben bekannten menschenwirksamen Coronaviren verursachen vier lediglich geringfügige Symptome - beispielsweise als Teil einer gewöhnlichen Erkältung. Mit einem Coronavirus waren die meisten bereits infiziert."
        },
        {
          frage: "Welcher Graph beschreibt eine ungehinderte Ausbreitung am besten?",
          items: [
            {text: 'exponentieller Verlauf', bild: 'expo.png'},
            {text: 'linearer Verlauf', bild: "linear.png"},
            {text: 'konstanter Verlauf', bild: "konst.png"}
          ],
          solution: "exponentieller Verlauf",
          erklärung: "Aufgrund des hohen Ansteckunsgrisikos und der schnellen Verbreitung über die Tröpcheninfektion handelt es sich um exponentielles Wachstum."
        },
        {
          frage: "Wann war die letzte von einem Coronavirus verursachte Pandemie?",
          items: [
            {text: '1989 / 1990'},
            {text: '1945 / 1946'},
            {text: '2002 / 2003'}
          ],
          solution: "2002 / 2003",
          erklärung: "Weltweites Auftreten von SARS - ausgelöst durch einen Coronavirus."
        },
        {
          frage: "Was bedeutet corona?",
          items: [
            {text: 'Kranz'},
            {text: 'Kraut'},
            {text: 'Kreuz'}
          ],
          solution: "Kranz",
          erklärung: "Von lat. corona - Kranz, weil SARS-CoV-2 unter dem Elektronenmikroskop einem Strahlenkranz gleiche Fortsätze aufweisen."
        }],
        model: {},
        ende: false
      }
    },
    methods: {
      goon: function() {
        if (this.fragen[this.cq].solution == this.model.text) {
          this.richtig = true
          this.kf++
        } else {
          this.richtig = false
        }
        this.model = {}
        if (this.eb) {
          if (this.cq < this.fragen.length - 1) {
            this.cq++
          } else {
            this.ende = true
          }
        }
        this.eb = !this.eb
        window.scrollTo(0, 0)
      }
    },
    watch: {
      $route: {
        immediate: true,
        handler(to, from) {
          lernzettelp.doc(this.$route.params.lernzettel).get().then(snapshot => this.lernzettel = snapshot.data()).then(() => this.$Progress.finish());
        }
      }
    },
    mounted: function(){
      if(this.$route.params.lernzettel !== ''){
        lernzettelp.doc(this.$route.params.lernzettel).get().then(snapshot => this.lernzettel = snapshot.data()).then(() => this.$Progress.finish());
      }
    },
    metaInfo(){
      if(this.lernzettel){
      return {
        title: "Stefan Zweig - " + this.lernzettel.name
      }
      }
    }
  }
</script>